import Filter from 'bad-words';
/**
 * Profanity filter for user-provided names in the auth flows
 * (CreateAccountForm and any future name-bearing forms in lincd-auth).
 *
 * Library: bad-words@3 — ~600 English profanity terms. We allowlist a small
 * set of legitimate first names that the library catches as false positives
 * (Dick, Fanny, Willy, Cock — all real names). Add to ALLOWLIST_NAMES as
 * more come up.
 *
 * This is duplicated from peacegame2 src/utils/name-validation.ts — both
 * stay in sync manually until/unless this gets promoted to a shared
 * workspace package (e.g. lincd-validation or lincd-input). Tracked in
 * peacegame2 plan 003.
 */
const ALLOWLIST_NAMES = ['dick', 'fanny', 'willy', 'cock'];
const filter = new Filter();
filter.removeWords(...ALLOWLIST_NAMES);
export function isCleanName(name) {
    const trimmed = name.trim();
    if (!trimmed)
        return true; // empty is "clean" — separate empty-check elsewhere
    return !filter.isProfane(trimmed);
}
//# sourceMappingURL=name-validation.js.map